import * as React from 'react';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';

const POPPER_OVERFLOW_PROPS = {
  modifiers: [
    {
      name: 'preventOverflow' as const,
      options: {
        boundary: 'viewport' as const,
        padding: { right: 20, left: 10, top: 10, bottom: 10 },
      },
    },
  ],
};

export const StatusTooltip = ({
  title,
  maxWidth,
  children,
  ...rest
}: {
  title: React.ReactNode;
  maxWidth?: number | string;
  children: TooltipProps['children'];
} & Omit<TooltipProps, 'title' | 'children'>) => (
  <Tooltip
    title={title}
    placement="top"
    arrow
    PopperProps={POPPER_OVERFLOW_PROPS}
    {...(maxWidth && {
      slotProps: { tooltip: { sx: { maxWidth } } },
    })}
    {...rest}
  >
    {children}
  </Tooltip>
);
